<template>
  <div
    class="page-header page-header-light"
    :class="[title == 'Dashboard' || title == 'แผงควบคุม' ? 'd-none d-sm-block':'']"
  >
    <!-- Show Mobile App Download -->
    <div
      v-if="showMobile"
      class="align-items-center bg-light border-bottom d-flex px-3 py-2"
    >
      <!-- <div class="align-items-center bg-light border-bottom d-flex px-3 py-2"> -->
      <div @click="closeMobileApp">
        <i class="fal fa-times fa-1x" />
      </div>
      <div class="mx-3">
        <!-- <img alt="App Goship" :src="$storeIndex.getImageSrc('Logo-App-Goship')" class="border" style="width: 56px; height: 56px; border-radius: 10px;" /> -->
        <img
          alt="App Goship"
          :src="$storeIndex.getImageSrc('Logo-App-Goship2')"
          style="width: 62px; height: 62px;  "
        >
      </div>
      <div class="mr-3">
        <h5 class="font-weight-semibold line-height-1 m-0 p-0">
          Goship
        </h5>
        <div class="font-size-sm text-grey">
          Goship Co.,Ltd.
        </div>
        <div class="line-height-1">
          <img
            :src="$storeIndex.getImageSrc('star-rating')"
            style=" height: 10px; "
          >
        </div>
        <div class="font-size-xs text-grey">
          GET - On the App Store
        </div>
      </div>
      <a
        class="btn btn-primary font-size-lg ml-auto rounded-round text-uppercase"
        style="letter-spacing: 1px;"
        :href="appUrl"
      >Open</a>
    </div>
    <!-- \Show Mobile App Download -->

    <div class="page-header-content header-elements-md-inline">
      <div class="page-title d-flex">
        <h4>
          <i
            class="fa-light fa-circle-arrow-left mr-2 pointer-cursor"
            @click="backToPrevPage"
            v-if="$route.meta.title != 'Home'"
          />
          <span class="font-weight-semibold">
            {{ $t(title) }}
            <span id="title-page" />
          </span>
        </h4>
      </div>
    </div>

    <div class="breadcrumb-line breadcrumb-line-light header-elements-md-inline">
      <div class="d-flex">
        <div class="breadcrumb ">
          <router-link
            to="/"
            class="breadcrumb-item"
          >
            <i class="fas fa-home-lg mr-2" /><span>{{ $t("Home") }}</span>
          </router-link>
          <router-link
            :to="breadcrumb.link || '#' "
            v-for="(breadcrumb, idx) in breadcrumbList"
            :key="idx"
            :class="[{'unlinked': !breadcrumb.link}, 'breadcrumb-item']"
          >
            {{ $t(breadcrumb.name) }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'HeaderContent',
    data() {
        return {
            title: '',
            item: this.$route,
            breadcrumbList: [],
            icon: '',

            userAgent: window.navigator.userAgent,
            platform: window.navigator.platform,
            macosPlatforms: ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms: ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms: ['iPhone', 'iPad', 'iPod'],
            os: null,
            showMobile: null,
            appUrl: 'javascript:void(0)',
        };
    },
    created() {},
    components: {},
    watch: {
        '$route'(newRoute) {
            this.showTitle();
            this.updateList();
        },
    },
    computed: {},
    methods: {
        showTitle() {
            let suffix = this.$route.meta.suffix;
            if (suffix === undefined) {
                suffix = ''
            } else {
                suffix = ' ' + this.$t(suffix);
            }
            this.title = this.$t(this.$route.meta.title);
            document.title = this.$t(this.$route.meta.title) + suffix;
            $("#title-page").html('');
        },
        updateList() {
            this.breadcrumbList = this.$route.meta.breadcrumb
        },
        documentClick(e) {},
        backToPrevPage() {
            const last = this.breadcrumbList;
            if (last.length > 1) {
                this.$router.push(last[last.length - 2].link);
            } else {
                this.$router.push("/");
            }
        },
        closeMobileApp() {
            this.showMobile = false;
            this.$cookie.set('hide_download_app', true);
        },
    },
    mounted() {
        this.updateList();
        this.showTitle();
        if (!this.$cookie.get('hide_download_app')) {

            if (this.macosPlatforms.indexOf(this.platform) !== -1) {
                this.os = 'Mac OS';
                this.showMobile = false;
            } else if (this.iosPlatforms.indexOf(this.platform) !== -1) {
                this.os = 'iOS';
                this.showMobile = true;
                this.appUrl = 'https://apps.apple.com/th/app/id1611302609';
            } else if (/Android/.test(this.userAgent)) {
                this.os = 'Android';
                this.showMobile = true;
                this.appUrl = 'https://play.google.com/store/apps';
            } else if (this.windowsPlatforms.indexOf(this.platform) !== -1) {
                this.os = 'Windows';
                this.showMobile = false;
            } else if (!this.os && /Linux/.test(this.platform)) {
                this.os = 'Linux';
                this.showMobile = false;
            }

        }

    }
};
</script>

<style scoped>
.pointer-cursor {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/HeaderContent.vue